import { capitalizeFirstLetter } from "../string";

export const activityTypeToName = (type) => {
    var return_string;
    if (type.includes("learning_material")) return_string = type.replace("learning_material", "").replace("_", " ").trim();
    else return_string = type.replace("_", " ").trim();
    return capitalizeFirstLetter(return_string);

  }
  